export const StorageConstants = {
    IDENTITY: 'identity',
    PLAYGROUND_STORE: 'playground_store',
    HAS_CUSTOM_SOCIAL_IMAGE: 'has_custom_social_image',
    EMAIL_INVITATION_TEXT: 'email_invitation_text',
    PUBLER_DISCOUNT_POPUP_DISMISSED: 'publer_discount_popup_dismissed',
    USER_SUBSCRIPTION_PREFIX: 'user_subscription-',
};
export const CookieConstants = {
    USER_ACCESS_TOKEN: 'user_access_token',
    PAGE_ID: 'pageId',
    NOLT_TOKEN: 'nolt_token',
};
export const PERSISTED_AUTH_COOKIE_DAYS = 400;
//# sourceMappingURL=storage.constants.js.map